import type { Mention, Publication } from "@/shared/types/mention";

/**
 * Atualizar a menção editada NO LUGAR, sem refazer a consulta do filtro
 * (pedido de 2026-11-03).
 *
 * Quem filtra "sem subtema" e põe o subtema numa menção não pode vê-la
 * sumir no meio do trabalho só porque ela deixou de casar com o filtro: a
 * lista fica como estava, com a linha mostrando o valor novo, e quem quer
 * o recorte de novo aperta "Atualizar". Por isso uma edição pontual (card,
 * modo revisão, drawer) busca só o detalhe DAQUELA menção e o encaixa na
 * posição dela; a página, a ordem e o total não mudam.
 *
 * O detalhe traz o texto INTEIRO da matéria, e a lista mostra o trecho:
 * trocar um pelo outro faria o card crescer depois de cada correção. O
 * texto não muda com edição de classificação, então o trecho da lista e
 * as posições do negrito sobre ele ficam como estavam.
 */
export function mergeMentionDetail(current: Mention, detail: Mention): Mention {
  return {
    ...detail,
    excerpt: current.excerpt,
    highlights: { ...detail.highlights, content: current.highlights.content },
  };
}

/** Troca a menção `detail.id` na lista, mantendo posição e trecho. */
export function replaceMentionInPlace(mentions: Mention[], detail: Mention): Mention[] {
  if (!mentions.some(mention => mention.id === detail.id)) return mentions;
  return mentions.map(mention =>
    mention.id === detail.id ? mergeMentionDetail(mention, detail) : mention,
  );
}

/**
 * Na visão Publicações a linha é o post, e a marca editada é uma entrada
 * de `brands`: só o que aquela entrada mostra (polaridade e nota) muda.
 */
export function replacePublicationBrandInPlace(
  publications: Publication[],
  detail: Mention,
): Publication[] {
  if (!publications.some(pub => pub.brands.some(brand => brand.mentionId === detail.id))) {
    return publications;
  }
  return publications.map(pub => ({
    ...pub,
    brands: pub.brands.map(brand =>
      brand.mentionId === detail.id
        ? { ...brand, polarity: detail.polarity, sentiment: detail.sentiment, cena: detail.cena }
        : brand,
    ),
  }));
}
